<template>
    <div class="sidemenu-container">
        <router-link class="item-wrapper" to="/main/myprofile">
            <div class="d-flex align-items-center">
                <img src="@/assets/icon/sidemenu/ic-inactive-user.svg" alt="">
                <div class="text"> {{ lbl.side_menu.profile }}</div>
            </div>
            <div class="arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <router-link class="item-wrapper" to="/main/changepassword">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-changepass.svg" alt="">
                <div class="text">{{ lbl.side_menu.changePassword }}</div>
            </div>
            <div class="arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <!-- TODO: add go to -->
        <router-link class="item-wrapper" to="/main">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-my-wishlist.svg" alt="">
                <div class="text">{{ lbl.side_menu.my_wishlist }}</div>
            </div>
            <div class="arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <router-link class="item-wrapper" to="/main">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-my-order.svg" alt="">
                <div class="text">{{ lbl.side_menu.my_order }}</div>
            </div>
            <div class="arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>

        <router-link class="item-wrapper" to="/main/contactus">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-contact.svg" alt="">
                <div class="text">{{ lbl.side_menu.contact_us }}</div>
            </div>
            <div class="arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <router-link class="item-wrapper" to="/main/faq">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-faq.svg" alt="">
                <div class="text">{{ lbl.side_menu.fag }}</div>
            </div>
            <div class=" arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <router-link class="item-wrapper" to="/main/language">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-language.svg" alt="">
                <div class="text">{{ lbl.side_menu.language }}</div>
            </div>
            <div class=" arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </router-link>
        <!-- region privacy -->
        <div class="item-wrapper" @click="gotoPrivacySetting('terms')">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-privacysetting.svg" alt="">
                <div class="text">{{ lbl.side_menu.privacy_setting }}</div>
            </div>
            <div class=" arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-down.png"/>
            </div>
        </div>
        <div class="item-wrapper" @click="gotoPrivacySetting('terms')">
            <div>
                <div class="sub-text">{{ lbl.side_menu.terms_conditions }}</div>
            </div>
        </div>
        <div class="item-wrapper" @click="gotoPrivacySetting('privacy')">
            <div>
                <div class="sub-text">{{ lbl.side_menu.privacy_policy }}</div>
            </div>
        </div>
        <div class="item-wrapper" @click="gotoPrivacySetting('marketing')">
            <div>
                <div class="sub-text">{{ lbl.side_menu.marketing_message }}</div>
            </div>
        </div>
        <div class="item-wrapper" @click="clickLogout()">
            <div class="d-flex">
                <img src="@/assets/icon/sidemenu/ic-inactive-logout.svg" alt="">
                <div class="text">{{ lbl.side_menu.logout }}</div>
            </div>
            <div class=" arrow-right">
                <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
            </div>
        </div>
        <!-- endregion privacy -->
        
        <!-- <div class="sidemenu-flex">
            <div class="sidemenu-height">

                
               

                <div class="item-wrapper" @click="clickUnconsent()">
                    <img v-if="$route.path == '/unconsent'" src="@/assets/icon/sidemenu/ic-active-unconsent.svg" alt="">
                    <img v-else src="@/assets/icon/sidemenu/ic-inactive-unconsent.svg" alt="">
                    <div class="d-flex">
                        <img src="@/assets/icon/sidemenu/ic-inactive-unconsent.svg" alt="">
                        <div class="text">{{ lbl.side_menu.unconsent }}</div>
                    </div>
                    <div class=" arrow-right">
                        <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
                    </div>
                </div>

                <div v-if="isShowLogout" class="item-wrapper" @click="clickLogout()">
                    <img v-if="$route.path == '/logout'" src="@/assets/icon/sidemenu/ic-active-logout.svg" alt="">
                    <img v-else src="@/assets/icon/sidemenu/ic-inactive-logout.svg" alt="">
                    <div class="d-flex">
                        <img src="@/assets/icon/sidemenu/ic-inactive-logout.svg" alt="">
                        <div class="text">{{ lbl.side_menu.logout }}</div>
                    </div>
                    <div class=" arrow-right">
                        <img src="@/assets/icon/sidemenu/ic-arrow-right.png"/>
                    </div>
                </div>

            </div>
            <div class="logo">
                <img src="@/assets/icon/bzbs-logo.svg" alt="">
            </div>
        </div> -->
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>

<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
// helper
import CacheHelper from '@/helper/CacheHelper';
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: 'SideMenu',
    mixins: [ModalMixin,LocaleMixin],
    data: function () {
        return {
            modalController: null,
            unconsentModal: null,
            logoutModal: null,

            appId: null,
        }
    },
    computed: {
    },
    created: function() {
    },
    mounted: function () {
        var cacheHelper = new CacheHelper();
        var cache = cacheHelper.getCache('BzbsUser');
        this.appId = cache.appId
    },
    methods: {
        gotoPrivacySetting: function (param) {
            if (this.$route.path.indexOf(`privacysetting${param}`) > 0 && this.$route.path === `/main/privacysetting/${param}`) return;
            if (this.$route.path === `/main/privacysetting/${param}`) return;
            this.$router.push(`/main/privacysetting/${param}`)
        },
        clickUnconsent: function () {
            this.unconsentModal
                .clearModal()
                .setTitle(this.lbl.unconsent_popup.title)
                .setMsg(this.lbl.unconsent_popup.msg)
                .setBtnOk(this.lbl.unconsent_popup.tel)
                .show()
            this.unconsentModal.onClickOk(() => {
                window.location ='tel:027603988';
            })
        },
        clickLogout: function () {
            this.logoutModal
                .clearModal()
                .setTitle(this.lbl.logout_popup.title)
                .setMsg(this.lbl.logout_popup.msg)
                .setBtnCancel(this.lbl.logout_popup.btnCancel)
                .setBtnOk(this.lbl.logout_popup.btnOk)
                .show()
            this.logoutModal.onClickOk(() => {
                var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
                cacheHelper.removeCache('BzbsUser');
                this.$nextTick(() => {
                    this.$router.push({ path: '/login', query: { app_id: this.appId } })
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    @import "./SideMenuMobile.scss";
</style>
